/**
 * Dónde se monta esta skin, en un solo sitio.
 *
 * El prefijo lo decide el shell y la skin construye sus rutas a partir de él:
 * mover el producto a otra ruta es una línea aquí, no una búsqueda por las
 * pantallas. Mismo patrón que Pencil Chief.
 */
export const CHECKME_BASE = "/check-me";

export const routes = {
  base: CHECKME_BASE,
  /** La consola abre por la jornada que está ocurriendo, no por un menú. */
  hoy: `${CHECKME_BASE}/hoy`,
  jornada: (shiftId: string) => `${CHECKME_BASE}/jornadas/${shiftId}`,
  parte: (shiftId: string) => `${CHECKME_BASE}/jornadas/${shiftId}/parte`,
  persona: (productionId: string, userId: string) =>
    `${CHECKME_BASE}/producciones/${productionId}/personas/${encodeURIComponent(userId)}`,
  convenio: (productionId: string) =>
    `${CHECKME_BASE}/producciones/${productionId}/convenio`,
  informes: (productionId: string) =>
    `${CHECKME_BASE}/producciones/${productionId}/informes`,
  equipo: (productionId: string) => `${CHECKME_BASE}/producciones/${productionId}/equipo`,
} as const;
